import { useFormContext } from 'react-hook-form';

import { ToggleSwitch } from '../../../../../../components/toggle-switch';
import { StrategyFormData } from '../../../../../../providers/backtesting/types';
import { CollapsibleSection } from '../../components/collapsible-section';
import { BacktestingInput } from '../../components/backtesting-input';
import { FormRow } from '../../components/form-row';
import { ToggleFieldRow } from '../../components/toggle-field-row';

import './styles.scss';

export const HedgingSection = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<StrategyFormData>();

  const hedgingErrors = errors.hedging;

  return (
    <CollapsibleSection title="Hedging*">
      <FormRow layout="flex" className="hedging-primary-row">
        <div className="field-group">
          <BacktestingInput
            size="lg"
            label="Frequency*"
            tooltip={`Either number of hours “1”, “2”, “3”, etc, or a string such as “15min”, or “0” for no hedging at all.`}
            placeholder="Hedging Frequency"
            {...register('hedging.frequency')}
            errors={hedgingErrors?.frequency?.message}
          />
        </div>

        <div className="toggle-inline hedging-funding-toggle">
          <div>
            <ToggleSwitch
              isOn={watch('hedging.includeFundingRates')}
              setIsOn={(val) => setValue('hedging.includeFundingRates', val)}
            />
          </div>
          <div className="toggle-inline-content">
            <span className="toggle-inline-label">Include funding rates</span>
            <div className="toggle-inline-description">
              Useful to see, for example, when an options strategy is paying or receiving funding.
            </div>
          </div>
        </div>
      </FormRow>

      <FormRow columns={5} minColumnWidth={220}>
        <ToggleFieldRow
          label="Delta threshold"
          description="Add the absolute delta threshold required to trigger hedging."
          isOn={watch('hedging.deltaThreshold')}
          onToggle={(val) => setValue('hedging.deltaThreshold', val)}
        >
          <BacktestingInput
            size="fluid"
            placeholder="Threshold"
            {...register('hedging.deltaThresholdValue')}
            errors={hedgingErrors?.deltaThresholdValue?.message}
          />
        </ToggleFieldRow>

        <ToggleFieldRow
          label="Delta threshold upper"
          description="Add the upper delta threshold required to trigger hedging."
          isOn={watch('hedging.deltaThresholdUpper')}
          onToggle={(val) => setValue('hedging.deltaThresholdUpper', val)}
        >
          <BacktestingInput
            size="fluid"
            placeholder="Upper"
            {...register('hedging.deltaThresholdUpperValue')}
            errors={hedgingErrors?.deltaThresholdUpperValue?.message}
          />
        </ToggleFieldRow>

        <ToggleFieldRow
          label="Delta threshold lower"
          description="Add the lower delta threshold required to trigger hedging."
          isOn={watch('hedging.deltaThresholdLower')}
          onToggle={(val) => setValue('hedging.deltaThresholdLower', val)}
        >
          <BacktestingInput
            size="fluid"
            placeholder="Lower"
            {...register('hedging.deltaThresholdLowerValue')}
            errors={hedgingErrors?.deltaThresholdLowerValue?.message}
          />
        </ToggleFieldRow>

        <ToggleFieldRow
          label="Delta target"
          description="Allows hedging to a custom delta target rather than zero."
          isOn={watch('hedging.deltaTarget')}
          onToggle={(val) => setValue('hedging.deltaTarget', val)}
        >
          <BacktestingInput
            size="fluid"
            placeholder="Target"
            {...register('hedging.deltaTargetValue')}
            errors={hedgingErrors?.deltaTargetValue?.message}
          />
        </ToggleFieldRow>

        <ToggleFieldRow
          label="Include token balance in delta"
          description="Count token balance towards delta threshold evaluation."
          isOn={watch('hedging.includeTokenBalanceInDelta')}
          onToggle={(val) => setValue('hedging.includeTokenBalanceInDelta', val)}
        />
      </FormRow>
    </CollapsibleSection>
  );
};
